
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_o08jm_1xwwv_9",
  "action-slot": "awsui_action-slot_o08jm_1xwwv_41",
  "group-layout": "awsui_group-layout_o08jm_1xwwv_46",
  "group-layout-horizontal": "awsui_group-layout-horizontal_o08jm_1xwwv_50",
  "group-layout-vertical": "awsui_group-layout-vertical_o08jm_1xwwv_53",
  "controls": "awsui_controls_o08jm_1xwwv_57",
  "controls-horizontal": "awsui_controls-horizontal_o08jm_1xwwv_61",
  "controls-vertical": "awsui_controls-vertical_o08jm_1xwwv_65",
  "controls-invalid": "awsui_controls-invalid_o08jm_1xwwv_68",
  "controls-warning": "awsui_controls-warning_o08jm_1xwwv_68",
  "control": "awsui_control_o08jm_1xwwv_57",
  "control-middle-horizontal": "awsui_control-middle-horizontal_o08jm_1xwwv_76",
  "control-last-horizontal": "awsui_control-last-horizontal_o08jm_1xwwv_76",
  "control-middle-vertical": "awsui_control-middle-vertical_o08jm_1xwwv_79",
  "control-last-vertical": "awsui_control-last-vertical_o08jm_1xwwv_79",
  "control-validation": "awsui_control-validation_o08jm_1xwwv_82",
  "control-first-horizontal": "awsui_control-first-horizontal_o08jm_1xwwv_93",
  "control-only-horizontal": "awsui_control-only-horizontal_o08jm_1xwwv_93",
  "control-only-vertical": "awsui_control-only-vertical_o08jm_1xwwv_93",
  "control-first-vertical": "awsui_control-first-vertical_o08jm_1xwwv_97",
  "control-in-error": "awsui_control-in-error_o08jm_1xwwv_103",
  "control-in-warning": "awsui_control-in-warning_o08jm_1xwwv_106",
  "inline-label": "awsui_inline-label_o08jm_1xwwv_115",
  "inline-label-wrapper": "awsui_inline-label-wrapper_o08jm_1xwwv_140",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_o08jm_1xwwv_145"
};
  